/** Mini-tab (collapsed widget) and disconnected-state badge. */
export const MINI_TAB_CSS = `
    .pw-mini-tab {
      position: fixed; bottom: 50px; right: 0;
      width: 29px; height: 32px;
      border-radius: 9999px 0 0 9999px;
      border: 1.2px solid transparent;
      background:
        var(--pw-fill-panel) padding-box,
        linear-gradient(transparent, transparent) padding-box,
        var(--pw-border-gradient) border-box;
      display: none; align-items: center; justify-content: center;
      cursor: pointer; pointer-events: auto; z-index: 2147483646;
      box-shadow: -2px 0 12px rgba(0, 0, 0, 0.16);
      user-select: none; outline: none;
      opacity: 0; transition: opacity 0.3s ease;
      font-family: var(--pw-font);
      color: var(--pw-text);
      padding: 0;
    }
    .pw-mini-tab:hover {
      background:
        var(--pw-gradient-overlay) padding-box, 
        var(--pw-fill-button) padding-box, 
        var(--pw-border-gradient) border-box;
    }
    .pw-mini-tab.visible { opacity: 1; }
    .pw-mini-tab.pw-perio-chart-minimized {
      visibility: hidden;
      pointer-events: none;
    }
    .pw-mini-tab svg { width: 16px; height: 16px; display: block; }
    .pw-mini-tab img {
      width: 16px; height: 16px; object-fit: contain; pointer-events: none;
    }

    .pw-badge {
      position: absolute;
      top: -1px;
      left: -1px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transform: scale(0.85);
      transition: opacity 0.15s ease, transform 0.15s ease;
      pointer-events: none;
      z-index: 60;
    }
    .pw-badge svg {
      width: 16px;
      height: 16px;
      display: block;
      filter: drop-shadow(0 0.5px 2px rgba(0, 0, 0, 0.22));
    }
    .pw-disconnected .pw-badge {
      opacity: 1;
      transform: scale(1);
    }
    .pw-mini-tab .pw-badge {
      top: -7px;
    }
`;
